import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { ApmService } from '@elastic/apm-rum-angular';
import { BehaviorSubject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { LoaderService } from '@pe/checkout/core/loader';
import { EnvironmentConfigInterface, PE_ENV } from '@pe/common';
import { PeDestroyService } from '@pe/destroy';

import { slideInOutAnimation } from './animations';

@Component({
  selector: 'checkout-root',
  styleUrls: ['./root.component.scss'],
  templateUrl: 'root.component.html',
  animations: [slideInOutAnimation],
  standalone: true,
  imports: [
    RouterOutlet,
    AsyncPipe,
  ],
  providers: [
    PeDestroyService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootComponent implements OnInit {

  protected readonly skeleton$ = new BehaviorSubject<SafeHtml>(null);

  protected isLoading = true;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly sanitizer: DomSanitizer,
    private readonly loaderService: LoaderService,
    private readonly apmService: ApmService,
    @Inject(PE_ENV) private env: EnvironmentConfigInterface,
    private readonly destroy$: PeDestroyService,
  ) {

    this.apmService.init({
      logLevel: 'error',
      serviceName: 'checkout-app',
      serverUrl: this.env.custom?.elasticUrl,
      disableInstrumentations: ['error', 'xmlhttprequest', 'fetch'],
      serviceVersion: 'MICRO_CHECKOUT_VERSION',
    });

    this.apmService.observe();

    // Skeleton is already loaded in index.html. We just place it on page again
    const indexPageSkeleton = window.document.getElementById('pe-index-page-skeleton-content');
    if (indexPageSkeleton) {
      this.skeleton$.next(this.sanitizer.bypassSecurityTrustHtml(indexPageSkeleton.innerHTML));
    } else {
      // This one comes from index.html
      (window as any).pe_onIndexPageSkeletonLoaded = () => {
        const indexPageSkeletonElem = window.document.getElementById('pe-index-page-skeleton-content');
        if (indexPageSkeletonElem) {
          this.skeleton$.next(this.sanitizer.bypassSecurityTrustHtml(indexPageSkeletonElem.innerHTML));
        }
      };
      // this.skeleton = '<div class="loader-container loader-fixed"><div class="loader_48"></div></div>';
    }
  }

  ngOnInit(): void {
    this.loaderService.loaderGlobal$
      .pipe(
        tap((isLoading: boolean) => {
          this.isLoading = isLoading;
          this.changeDetectorRef.detectChanges();
        }),
        takeUntil(this.destroy$),
      ).subscribe();
  }
}
